import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageComponent, PageService, Transfer, Shell, Page, PagedArray } from '@tytapp/common';
import { Show, Production } from '@tytapp/models';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiShow, ApiTuneInProvider } from 'api';
import { Observable, combineLatest } from 'rxjs';
import { ProductionsService, ShowsService } from '@tytapp/common-ui';
import {UserService} from '@tytapp/user';

@Page('podcasts')
@Component({
  selector: 'tyt-podcasts',
  templateUrl: './podcasts.component.html',
  styleUrls: ['./podcasts.component.scss']
})
export class PodcastsComponent extends PageComponent {

  constructor(
    private route : ActivatedRoute,
    private productionsService : ProductionsService,
    private userService : UserService,
    private showsService : ShowsService,
    private elementRef : ElementRef<HTMLElement>,
    pageService : PageService
  ) {
    super(pageService);
  }

  get pageComponentId() {
    return 'podcasts';
  }

  @Transfer()
  shows : PagedArray<Show>; 

  @Transfer()
  audienceType : string = 'visitor';

  @Transfer()
  bgImageToUse = '';

  @Transfer()
  topShowId : string;

  @ViewChild('heroImage', { static: true })
  heroImageElement : ElementRef<HTMLElement>;

  hideComponents = false;

  private scrollHandler;
  private debounceTimeout;
  private scrollDebounceTimeout;

  isAboveFold(show : Show) {
    let index = this.shows.indexOf(show);
    let topIndex = this.shows.findIndex(x => x.id === this.topShowId);
    return (index < topIndex);
  }
  
  async init() {
    this.audienceType = this.userService.audienceType;
    this.pageTitle = 'Podcasts';

    if (!this.hasServerState) {
      this.shows = <any> await this.showsService.all();
      if (this.shows.length > 0)
        this.bgImageToUse = this.shows[0].web_header_image;
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.scrollHandler = () => {
        clearTimeout(this.scrollDebounceTimeout);
        this.scrollDebounceTimeout = setTimeout(() => {
          this.updatePodcastImage();
        }, 100);
      });
    }
  }

  async destroy() {
    if (typeof window !== 'undefined')
      window.removeEventListener('scroll', this.scrollHandler);
  }

  private updatePodcastImage() {
    if (!this.heroImageElement)
      return;
    if (!this.shows || this.shows.length === 0)
      return;

    let heroImageRect = this.heroImageElement.nativeElement.getBoundingClientRect();
    let cutoff = heroImageRect.top + heroImageRect.height - 100;
    let element = this.elementRef.nativeElement;
    let activeShow : Show = null;
    let showElements = new Map<string,HTMLElement>(
      <any>Array.from(element.querySelectorAll(`tyt-podcast-item`))
        .map(e => [e.getAttribute('data-show'), e])
    );

    for (let show of this.shows) {
      let showElement = showElements.get(show.id);
      if (!showElement) {
        console.warn(`Could not find element for show ${show.id}!`);
        continue;
      }

      let showElementBounds = showElement.getBoundingClientRect();
      let yPos = showElementBounds.top;
      let height = showElementBounds.height;

      if (yPos > cutoff) {
        activeShow = show;
        break;
      }
    }

    this.hideComponents = !activeShow;
    if (activeShow) {
      this.topShowId = activeShow.id;
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.bgImageToUse = activeShow.web_header_image;
      }, 100);
    } else {
      this.topShowId = null;
    }
  }
}
